import PropTypes from 'prop-types'
import { ThemeProvider, CacheProvider, Global } from '@emotion/react'
import { theme } from 'chaoskit/src/assets/styles/theme'
import { MDXProvider } from '@mdx-js/react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { cache } from '@emotion/css'
import { globalStyles } from 'chaoskit/src/assets/styles/global'

import { global as localGlobalStyles } from '~styles/global'
import { shortcodes } from '~components/mdxShortcodes'

const queryClient = new QueryClient()

export const savedCache = cache

export default function Wrap({ element }) {
  return (
    <CacheProvider value={savedCache}>
      <ThemeProvider theme={theme}>
        <Global styles={[globalStyles(theme), localGlobalStyles(theme)]} />
        <MDXProvider components={shortcodes}>
          <QueryClientProvider client={queryClient}>
            {element}
          </QueryClientProvider>
        </MDXProvider>
      </ThemeProvider>
    </CacheProvider>
  )
}

Wrap.propTypes = {
  element: PropTypes.any,
}
